<script>
import Layout from "../../../layouts/main";
import axios from "axios";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import {
	getHomePage,
	updateHomePage,
} from "../../../../api/services/cms.service";
import { getS3SingedUrl } from "../../../../api/services/general.service";
import ImageCroperModel from "../../../../components/models/image-crop.vue";
import { newHomepageObject } from "./homepage-controller";

/**
 * Manage Homepage Page
 */
export default {
	page: {
		title: "Startseite Verwalten",
		meta: [
			{
				name: "description",
				content: appConfig.description,
			},
		],
	},
	components: {
		Layout,
		PageHeader,
		"image-cropper-model": ImageCroperModel,
	},
	data() {
		return {
			title: this.$i18n.t("CMS.homePage.mangeHomePage"),
			items: [
				{
					text: this.$i18n.t("CMS.homePage.mangeHomePage"),
					active: true,
				},
			],
			homepageId: null,

			banner_image: null,
			bannerImageFile: null,
			bannerImage_URL: null,

			card3_img: null,
			aboutImage_1: null,
			aboutImage_1_URL: null,

			card4_img: null,
			aboutImage_2: null,
			aboutImage_2_URL: null,

			danube_videolink: null,
			danube_title: null,
			danube_description: null,
			aboutus_title: null,
			aboutus_description: "",
			card1_title: null,
			card1_description: null,
			card2_title: null,
			card2_description: null,

			slider_galary: [],
			slider_URL: [],
			editHomepageProcessing: false,
			editHomepageSuccess: false,
			editHomepageFailed: false,
			croppedPackageImage: null,
			showPackageImageCropModel: null,
			showEditHomepageModel: true,
			homepage: null,
			homepageToEdit: null,

			sliderImage_1: null,
			sliderImage_2: null,
			sliderImage_3: null,
			sliderImage_4: null,
			sliderImage_5: null,
			sliderImage_6: null,
			sliderImage_7: null,
			sliderImage_8: null,
			sliderImage_9: null,

			sliderImageURL_1: null,
			sliderImageURL_2: null,
			sliderImageURL_3: null,
			sliderImageURL_4: null,
			sliderImageURL_5: null,
			sliderImageURL_6: null,
			sliderImageURL_7: null,
			sliderImageURL_8: null,
			sliderImageURL_9: null,

			showSliderImageOneCropModel: false,
			sliderImageOneFileToCrop: null,
			croppedExtraImage: null,

			showSliderImageTwoCropModel: false,
			sliderImageTwoFileToCrop: null,
			croppedSliderImageTwo: null,

			showSliderImageThreeCropModel: false,
			sliderImageThreeFileToCrop: null,
			croppedSliderImageThree: null,

			showSliderImageFourCropModel: false,
			sliderImageFourFileToCrop: null,
			croppedSliderImageFour: null,

			showSliderImageFiveCropModel: false,
			sliderImageFiveFileToCrop: null,
			croppedSliderImageFive: null,

			showSliderImageSixCropModel: false,
			sliderImageSixFileToCrop: null,
			croppedSliderImageSix: null,

			showSliderImageSevenCropModel: false,
			sliderImageSevenFileToCrop: null,
			croppedSliderImageSeven: null,

			showSliderImageEightCropModel: false,
			sliderImageEightFileToCrop: null,
			croppedSliderImageEight: null,

			showSliderImageNineCropModel: false,
			sliderImageNineFileToCrop: null,
			croppedSliderImageNine: null,
		};
	},
	validations: {
		banner_image: { required },
		danube_videolink: { required },
		danube_title: { required },
		danube_description: { required },
		aboutus_title: { required },
		aboutus_description: { required },
		card1_title: { required },
		card1_description: { required },
		card2_title: { required },
		card2_description: { required },
		card3_img: { required },
		card4_img: { required },
		slider_galary: { required },
	},
	async mounted() {
		await this.getHomepage();
	},
	methods: {
		async getHomepage() {
			let getHomepages = await getHomePage();
			if (getHomepages.length > 0) {
				this.homepage = getHomepages[0];
				this.homepageId = this.homepage.id;
				this.banner_image = this.homepage.banner_image;
				this.danube_videolink = this.homepage.danube_videolink;
				this.danube_title = this.homepage.danube_title;
				this.danube_description = this.homepage.danube_description;
				this.aboutus_title = this.homepage.aboutus_title;
				this.aboutus_description = this.homepage.aboutus_description;
				this.card1_title = this.homepage.card1_title;
				this.card1_description = this.homepage.card1_description;
				this.card2_title = this.homepage.card2_title;
				this.card2_description = this.homepage.card2_description;
				this.card3_img = this.homepage.card3_img;
				this.card4_img = this.homepage.card4_img;
				this.slider_galary = this.homepage.slider_galary;
				this.slider_URL = this.homepage.slider_URL;
			}
		},
		async clickSaveButton() {
			if (this.bannerImageFile) {
				this.banner_image = await this.getS3PresignedUrl(
					this.bannerImageFile.name,
					this.bannerImageFile
				);
			}

			if (this.aboutImage_1) {
				this.card3_img = await this.getS3PresignedUrl(
					this.aboutImage_1.name,
					this.aboutImage_1
				);
			}

			if (this.aboutImage_2) {
				this.card4_img = await this.getS3PresignedUrl(
					this.aboutImage_2.name,
					this.aboutImage_2
				);
			}

			if (this.croppedSliderImageOne) {
				const imageFile = this.$refs.extraImageInput.files[0];
				const croppedImage = this.croppedSliderImageOne;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.slider_galary[0] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedSliderImageTwo) {
				const imageFile = this.$refs.sliderImageTwoInput.files[0];
				const croppedImage = this.croppedSliderImageTwo;

				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.slider_galary[1] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedSliderImageThree) {
				const imageFile = this.$refs.sliderImageThreeInput.files[0];
				const croppedImage = this.croppedSliderImageThree;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.slider_galary[2] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedSliderImageFour) {
				const imageFile = this.$refs.sliderImageFourInput.files[0];
				const croppedImage = this.croppedSliderImageFour;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.slider_galary[3] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedSliderImageFive) {
				const imageFile = this.$refs.sliderImageFiveInput.files[0];
				const croppedImage = this.croppedSliderImageFive;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.slider_galary[4] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedSliderImageSix) {
				const imageFile = this.$refs.sliderImageSixInput.files[0];
				const croppedImage = this.croppedSliderImageSix;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.slider_galary[5] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedSliderImageSeven) {
				const imageFile = this.$refs.sliderImageSevenInput.files[0];
				const croppedImage = this.croppedSliderImageSeven;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.slider_galary[6] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedSliderImageEight) {
				const imageFile = this.$refs.sliderImageEightInput.files[0];
				const croppedImage = this.croppedSliderImageEight;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.slider_galary[7] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedSliderImageNine) {
				const imageFile = this.$refs.sliderImageNineInput.files[0];
				const croppedImage = this.croppedSliderImageNine;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.slider_galary[8] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}

			this.editHomepageProcessing = true;
			let editedHomepageObject_Pass = new newHomepageObject();
			editedHomepageObject_Pass.banner_image = this.banner_image;
			editedHomepageObject_Pass.danube_videolink = this.danube_videolink;
			editedHomepageObject_Pass.danube_title = this.danube_title;
			editedHomepageObject_Pass.danube_description = this.danube_description;
			editedHomepageObject_Pass.aboutus_title = this.aboutus_title;
			editedHomepageObject_Pass.aboutus_description = this.aboutus_description;
			editedHomepageObject_Pass.card1_title = this.card1_title;
			editedHomepageObject_Pass.card1_description = this.card1_description;
			editedHomepageObject_Pass.card2_title = this.card2_title;
			editedHomepageObject_Pass.card2_description = this.card2_description;

			editedHomepageObject_Pass.card3_img = this.card3_img;
			editedHomepageObject_Pass.card4_img = this.card4_img;
			editedHomepageObject_Pass.slider_galary = this.slider_galary;
			editedHomepageObject_Pass.slider_URL = this.slider_URL;

			let homepageEditSuccess = await updateHomePage(
				this.homepageId,
				editedHomepageObject_Pass
			);

			if (homepageEditSuccess) {
				this.editHomepageProcessing = false;
				this.editHomepageSuccess = true;
				this.realodPage();
			} else if (!homepageEditSuccess) {
				this.editHomepageProcessing = false;
				this.editHomepageFailed = true;
			}
			// } else {
			//   this.editHomepageProcessing = false;
			//   console.log("Validation Error"); //eslint-disable-line
			// }
		},
		clickCloseButton() {
			this.$emit("reload");
		},
		handleBannerImageSelect() {
			this.bannerImageFile = this.$refs.bannerImageRef.files[0];
			this.banner_image = URL.createObjectURL(this.bannerImageFile);
			this.bannerImage_URL = URL.createObjectURL(this.bannerImageFile);
		},
		handleAboutnImage1Select() {
			this.aboutImage_1 = this.$refs.aboutImage_1_Ref.files[0];
			this.card3_img = URL.createObjectURL(this.aboutImage_1);
			this.aboutImage_1_URL = URL.createObjectURL(this.aboutImage_1);
		},
		handleAboutnImage2Select() {
			this.aboutImage_2 = this.$refs.aboutImage_2_Ref.files[0];
			this.card4_img = URL.createObjectURL(this.aboutImage_2);
			this.aboutImage_2_URL = URL.createObjectURL(this.aboutImage_2);
		},

		// Slider image select handlers
		handleSliderImage1Select() {
			this.sliderImage_1 = this.$refs.sliderImage_1.files[0];
			this.slider_galary[0] = URL.createObjectURL(this.sliderImage_1);
			this.sliderImageURL_1 = URL.createObjectURL(this.sliderImage_1);
		},
		handleSliderImage2Select() {
			this.sliderImage_2 = this.$refs.sliderImage_2.files[0];
			this.slider_galary[1] = URL.createObjectURL(this.sliderImage_2);
			this.sliderImageURL_2 = URL.createObjectURL(this.sliderImage_2);
		},
		handleSliderImage3Select() {
			this.sliderImage_3 = this.$refs.sliderImage_3.files[0];
			this.slider_galary[2] = URL.createObjectURL(this.sliderImage_3);
			this.sliderImageURL_3 = URL.createObjectURL(this.sliderImage_3);
		},
		handleSliderImage4Select() {
			this.sliderImage_4 = this.$refs.sliderImage_4.files[0];
			this.slider_galary[3] = URL.createObjectURL(this.sliderImage_4);
			this.sliderImageURL_4 = URL.createObjectURL(this.sliderImage_4);
		},
		handleSliderImage5Select() {
			this.sliderImage_5 = this.$refs.sliderImage_5.files[0];
			this.slider_galary[4] = URL.createObjectURL(this.sliderImage_5);
			this.sliderImageURL_5 = URL.createObjectURL(this.sliderImage_5);
		},
		handleSliderImage6Select() {
			this.sliderImage_6 = this.$refs.sliderImage_6.files[0];
			this.slider_galary[5] = URL.createObjectURL(this.sliderImage_6);
			this.sliderImageURL_6 = URL.createObjectURL(this.sliderImage_6);
		},
		handleSliderImage7Select() {
			this.sliderImage_7 = this.$refs.sliderImage_7.files[0];
			this.slider_galary[6] = URL.createObjectURL(this.sliderImage_7);
			this.sliderImageURL_7 = URL.createObjectURL(this.sliderImage_7);
		},
		handleSliderImage8Select() {
			this.sliderImage_8 = this.$refs.sliderImage_8.files[0];
			this.slider_galary[7] = URL.createObjectURL(this.sliderImage_8);
			this.sliderImageURL_8 = URL.createObjectURL(this.sliderImage_8);
		},
		handleSliderImage9Select() {
			this.sliderImage_9 = this.$refs.sliderImage_9.files[0];
			this.slider_galary[8] = URL.createObjectURL(this.sliderImage_9);
			this.sliderImageURL_9 = URL.createObjectURL(this.sliderImage_9);
		},
		async getS3PresignedUrl(fileName, file) {
			let getUploadedFileURL = await getS3SingedUrl(fileName);

			let getFileUploadResponse = await axios.put(
				getUploadedFileURL.signedUrl,
				file
			);

			let fileBaseUrl =
				"https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/";

			if (getFileUploadResponse) {
				return fileBaseUrl + fileName;
			}
			return null;
		},
		realodPage() {
			window.location.reload();
		},
		// Image Crop
		extraImageSelected() {
			const imagePreviewCanvers = this.$refs.extraImageCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const extraImageFile = this.$refs.extraImageInput.files[0];
			this.openCorpExtraImageModel(extraImageFile);
		},
		openCorpExtraImageModel(extraImageFile) {
			this.sliderImageOneFileToCrop = extraImageFile;
			this.showSliderImageOneCropModel = true;
		},
		setCroppedImageToPreview(croppedImage) {
			const imagePreview = this.$refs.extraImagePreview;
			const imagePreviewCanvers = this.$refs.extraImageCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageOne = croppedImage;
			this.showSliderImageOneCropModel = false;
		},

		// Slider image 2
		sliderImageTwoSelected() {
			const imagePreviewCanvers = this.$refs.sliderImageTwoCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.sliderImageTwoInput.files[0];
			this.openCorpSliderImageTwoModel(imageFile);
		},
		openCorpSliderImageTwoModel(imageFile) {
			this.sliderImageTwoFileToCrop = imageFile;
			this.showSliderImageTwoCropModel = true;
		},
		setCroppedSliderImageTwoToPreview(croppedImage) {
			const imagePreview = this.$refs.sliderImageTwoPreview;
			const imagePreviewCanvers = this.$refs.sliderImageTwoCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageTwo = croppedImage;
			this.showSliderImageTwoCropModel = false;
		},

		// Slider image 3
		sliderImageThreeSelected() {
			const imagePreviewCanvers = this.$refs.sliderImageThreeCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.sliderImageThreeInput.files[0];
			this.openCorpSliderImageThreeModel(imageFile);
		},
		openCorpSliderImageThreeModel(imageFile) {
			this.sliderImageThreeFileToCrop = imageFile;
			this.showSliderImageThreeCropModel = true;
		},
		setCroppedSliderImageThreeToPreview(croppedImage) {
			const imagePreview = this.$refs.sliderImageThreePreview;
			const imagePreviewCanvers = this.$refs.sliderImageThreeCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageThree = croppedImage;
			this.showSliderImageThreeCropModel = false;
		},

		// Slider image 4
		sliderImageFourSelected() {
			const imagePreviewCanvers = this.$refs.sliderImageFourCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.sliderImageFourInput.files[0];
			this.openCorpSliderImageFourModel(imageFile);
		},
		openCorpSliderImageFourModel(imageFile) {
			this.sliderImageFourFileToCrop = imageFile;
			this.showSliderImageFourCropModel = true;
		},
		setCroppedSliderImageFourToPreview(croppedImage) {
			const imagePreview = this.$refs.sliderImageFourPreview;
			const imagePreviewCanvers = this.$refs.sliderImageFourCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageFour = croppedImage;
			this.showSliderImageFourCropModel = false;
		},

		// Slider image 5
		sliderImageFiveSelected() {
			const imagePreviewCanvers = this.$refs.sliderImageFiveCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.sliderImageFiveInput.files[0];
			this.openCorpSliderImageFiveModel(imageFile);
		},
		openCorpSliderImageFiveModel(imageFile) {
			this.sliderImageFiveFileToCrop = imageFile;
			this.showSliderImageFiveCropModel = true;
		},
		setCroppedSliderImageFiveToPreview(croppedImage) {
			const imagePreview = this.$refs.sliderImageFivePreview;
			const imagePreviewCanvers = this.$refs.sliderImageFiveCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageFive = croppedImage;
			this.showSliderImageFiveCropModel = false;
		},

		// Slider image 6
		sliderImageSixSelected() {
			const imagePreviewCanvers = this.$refs.sliderImageSixCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.sliderImageSixInput.files[0];
			this.openCorpSliderImageSixModel(imageFile);
		},
		openCorpSliderImageSixModel(imageFile) {
			this.sliderImageSixFileToCrop = imageFile;
			this.showSliderImageSixCropModel = true;
		},
		setCroppedSliderImageSixToPreview(croppedImage) {
			const imagePreview = this.$refs.sliderImageSixPreview;
			const imagePreviewCanvers = this.$refs.sliderImageSixCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageSix = croppedImage;
			this.showSliderImageSixCropModel = false;
		},

		// Slider image 7
		sliderImageSevenSelected() {
			const imagePreviewCanvers = this.$refs.sliderImageSevenCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.sliderImageSevenInput.files[0];
			this.openCorpSliderImageSevenModel(imageFile);
		},
		openCorpSliderImageSevenModel(imageFile) {
			this.sliderImageSevenFileToCrop = imageFile;
			this.showSliderImageSevenCropModel = true;
		},
		setCroppedSliderImageSevenToPreview(croppedImage) {
			const imagePreview = this.$refs.sliderImageSevenPreview;
			const imagePreviewCanvers = this.$refs.sliderImageSevenCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageSeven = croppedImage;
			this.showSliderImageSevenCropModel = false;
		},

		// Slider image 8
		sliderImageEightSelected() {
			const imagePreviewCanvers = this.$refs.sliderImageEightCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.sliderImageEightInput.files[0];
			this.openCorpSliderImageEightModel(imageFile);
		},
		openCorpSliderImageEightModel(imageFile) {
			this.sliderImageEightFileToCrop = imageFile;
			this.showSliderImageEightCropModel = true;
		},
		setCroppedSliderImageEightToPreview(croppedImage) {
			const imagePreview = this.$refs.sliderImageEightPreview;
			const imagePreviewCanvers = this.$refs.sliderImageEightCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageEight = croppedImage;
			this.showSliderImageEightCropModel = false;
		},

		// Slider image 9
		sliderImageNineSelected() {
			const imagePreviewCanvers = this.$refs.sliderImageNineCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.sliderImageNineInput.files[0];
			this.openCorpSliderImageNineModel(imageFile);
		},
		openCorpSliderImageNineModel(imageFile) {
			this.sliderImageNineFileToCrop = imageFile;
			this.showSliderImageNineCropModel = true;
		},
		setCroppedSliderImageNineToPreview(croppedImage) {
			const imagePreview = this.$refs.sliderImageNinePreview;
			const imagePreviewCanvers = this.$refs.sliderImageNineCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageNine = croppedImage;
			this.showSliderImageNineCropModel = false;
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<!-- About us Section -->
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<div class="card-title">
							{{ $t("CMS.homePage.manageAboutTopic") }}
						</div>
						<div class="row">
							<!-- About Main -->
							<div class="col-md-4">
								<div class="mt-3 mb-4">
									<label>
										{{ $t("CMS.homePage.titleLabel") }}
										<span class="text-danger">*</span>
										<span class="ml-2">
											<p
												v-if="aboutus_title"
												class="badge position-absolute"
												:class="{
													'badge-light': aboutus_title.length !== 30,
													'badge-danger': aboutus_title.length === 30,
												}"
											>
												{{ aboutus_title.length }} / 30
											</p>
										</span>
									</label>
									<b-form-group>
										<b-form-input
											v-model="aboutus_title"
											:maxlength="30"
											:placeholder="
												this.$i18n.t('CMS.homePage.titlePlaceholder')
											"
											:class="{ 'is-invalid': $v.aboutus_title.$error }"
										></b-form-input>
										<div v-if="$v.card2_title.$error" class="invalid-feedback">
											<span
												v-if="$v.card2_title.$error && !$v.card2_title.required"
												>{{ $t("packages.editPackage.titleRequiredMsg") }}</span
											>
										</div>
									</b-form-group>
								</div>
								<div class="mt-3 mb-4">
									<label>
										{{ $t("CMS.homePage.descriptionLabel") }}
										<span class="text-danger">*</span>
										<span class="ml-2">
											<p
												v-if="aboutus_description"
												class="badge position-absolute"
												:class="{
													'badge-light': aboutus_description.length !== 650,
													'badge-danger': aboutus_description.length === 650,
												}"
											>
												{{ aboutus_description.length }} / 650
											</p>
										</span>
									</label>
									<textarea
										v-model="aboutus_description"
										class="form-control"
										name="textarea"
										rows="5"
										:maxlength="650"
										:placeholder="
											this.$i18n.t('CMS.homePage.descriptionPlaceholder')
										"
										:class="{ 'is-invalid': $v.aboutus_description.$error }"
									></textarea>
									<div
										v-if="$v.aboutus_description.$error"
										class="invalid-feedback"
									>
										<span
											v-if="
												$v.aboutus_description.$error &&
													!$v.aboutus_description.required
											"
											>{{
												$t("packages.editPackage.descriptionRequiredMsg")
											}}</span
										>
									</div>
								</div>
							</div>
							<!-- About Card 1 -->
							<div class="col-md-4">
								<div class="mt-3 mb-4">
									<label>
										{{ $t("CMS.homePage.cardOneTopic") }}
										<span class="text-danger">*</span>
										<span class="ml-2">
											<p
												v-if="card1_title"
												class="badge position-absolute"
												:class="{
													'badge-light': card1_title.length !== 20,
													'badge-danger': card1_title.length === 20,
												}"
											>
												{{ card1_title.length }} / 20
											</p>
										</span>
									</label>
									<b-form-group>
										<b-form-input
											v-model="card1_title"
											:maxlength="20"
											:placeholder="
												this.$i18n.t('CMS.homePage.titlePlaceholder')
											"
											:class="{ 'is-invalid': $v.card1_title.$error }"
										></b-form-input>
									</b-form-group>
									<div v-if="$v.card2_title.$error" class="invalid-feedback">
										<span
											v-if="$v.card2_title.$error && !$v.card2_title.required"
											>{{ $t("packages.editPackage.titleRequiredMsg") }}</span
										>
									</div>
								</div>
								<div class="mt-3 mb-4">
									<label>
										{{ $t("CMS.homePage.descriptionLabel") }}
										<span class="text-danger">*</span>
										<span class="ml-2">
											<p
												v-if="card1_description"
												class="badge position-absolute"
												:class="{
													'badge-light': card1_description.length !== 140,
													'badge-danger': card1_description.length === 140,
												}"
											>
												{{ card1_description.length }} / 140
											</p>
										</span>
									</label>
									<textarea
										v-model="card1_description"
										class="form-control"
										name="textarea"
										rows="5"
										:maxlength="140"
										:placeholder="
											this.$i18n.t('CMS.homePage.descriptionPlaceholder')
										"
										:class="{ 'is-invalid': $v.card1_description.$error }"
									></textarea>
									<div
										v-if="$v.card1_description.$error"
										class="invalid-feedback"
									>
										<span
											v-if="
												$v.card1_description.$error &&
													!$v.card1_description.required
											"
											>{{
												$t("packages.editPackage.descriptionRequiredMsg")
											}}</span
										>
									</div>
								</div>
							</div>
							<!-- About Card 2 -->
							<div class="col-md-4">
								<div class="mt-3 mb-4">
									<label>
										{{ $t("CMS.homePage.cardTwoTopic") }}
										<span class="text-danger">*</span>
										<span class="ml-2">
											<p
												v-if="card2_title"
												class="badge position-absolute"
												:class="{
													'badge-light': card2_title.length !== 20,
													'badge-danger': card2_title.length === 20,
												}"
											>
												{{ card2_title.length }} / 20
											</p>
										</span>
									</label>
									<b-form-group>
										<b-form-input
											v-model="card2_title"
											:maxlength="20"
											:placeholder="
												this.$i18n.t('CMS.homePage.titlePlaceholder')
											"
											:class="{ 'is-invalid': $v.card2_title.$error }"
										></b-form-input>
									</b-form-group>
									<div v-if="$v.card2_title.$error" class="invalid-feedback">
										<span
											v-if="$v.card2_title.$error && !$v.card2_title.required"
											>{{ $t("packages.editPackage.titleRequiredMsg") }}</span
										>
									</div>
								</div>
								<div class="mt-3 mb-4">
									<label>
										{{ $t("CMS.homePage.descriptionLabel") }}
										<span class="text-danger">*</span>
										<span class="ml-2">
											<p
												v-if="card2_description"
												class="badge position-absolute"
												:class="{
													'badge-light': card2_description.length !== 140,
													'badge-danger': card2_description.length === 140,
												}"
											>
												{{ card2_description.length }} / 140
											</p>
										</span>
									</label>
									<textarea
										v-model="card2_description"
										class="form-control"
										name="textarea"
										rows="5"
										:maxlength="140"
										:placeholder="
											this.$i18n.t('CMS.homePage.descriptionPlaceholder')
										"
										:class="{ 'is-invalid': $v.card2_description.$error }"
									></textarea>
									<div
										v-if="$v.card2_description.$error"
										class="invalid-feedback"
									>
										<span
											v-if="
												$v.card2_description.$error &&
													!$v.card2_description.required
											"
											>{{
												$t("packages.editPackage.descriptionRequiredMsg")
											}}</span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Image Section -->
		<div class="row mt-4">
			<div class="col-md-12">
				<div class="row">
					<!-- Main Banner-->
					<div class="col-md-4">
						<div class="card">
							<div class="card-body">
								<div class="card-title">
									Banner-Bild
									<span class="ml-2">
										<input
											id="bannerImage"
											ref="bannerImageRef"
											type="file"
											name="file"
											accept="image/*"
											style="width: 0.1px; opacity: 0; z-index: -1"
											@change="handleBannerImageSelect()"
										/>
										<span>
											<label
												for="bannerImage"
												class="text-info"
												style="cursor: pointer"
											>
												<i class="bx bxs-message-square-edit text-warning"></i>
											</label>
										</span>
									</span>
								</div>
								<div class="mt-3">
									<img
										v-if="!bannerImage"
										v-bind:src="banner_image"
										style="width: 100%"
									/>
									<img
										v-if="bannerImage"
										:src="bannerImage_URL"
										style="width: 100%"
									/>
								</div>
							</div>
						</div>
					</div>
					<!-- About Section Image 1-->
					<div class="col-md-4">
						<div class="card">
							<div class="card-body">
								<div class="card-title">
									Über den Bereich Bild 1
									<span class="ml-2">
										<input
											id="aboutImage_1"
											ref="aboutImage_1_Ref"
											type="file"
											name="file"
											accept="image/*"
											style="width: 0.1px; opacity: 0; z-index: -1"
											@change="handleAboutnImage1Select()"
										/>
										<span>
											<label
												for="aboutImage_1"
												class="text-info"
												style="cursor: pointer"
											>
												<i class="bx bxs-message-square-edit text-warning"></i>
											</label>
										</span>
									</span>
								</div>
								<div class="mt-3">
									<img
										v-if="!aboutImage_1"
										v-bind:src="card3_img"
										style="width: 100%; height: 240px"
									/>
									<img
										v-if="aboutImage_1"
										:src="aboutImage_1_URL"
										style="width: 100%; height: 240px"
									/>
								</div>
							</div>
						</div>
					</div>
					<!-- About section Image 2-->
					<div class="col-md-4">
						<div class="card">
							<div class="card-body">
								<div class="card-title">
									Über den Bereich Bild 2
									<span class="ml-2">
										<input
											id="aboutImage_2"
											ref="aboutImage_2_Ref"
											type="file"
											name="file"
											accept="image/*"
											style="width: 0.1px; opacity: 0; z-index: -1"
											@change="handleAboutnImage2Select()"
										/>
										<span>
											<label
												for="aboutImage_2"
												class="text-info"
												style="cursor: pointer"
											>
												<i class="bx bxs-message-square-edit text-warning"></i>
											</label>
										</span>
									</span>
								</div>
								<div class="mt-3">
									<img
										v-if="!aboutImage_2"
										v-bind:src="card4_img"
										style="width: 100%"
									/>
									<img
										v-if="aboutImage_2"
										:src="aboutImage_2_URL"
										style="width: 100%"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Danube Section -->
		<div class="row mt-4">
			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body">
								<div class="card-title">
									{{ $t("CMS.homePage.manageDanubeTopic") }}
								</div>
								<div class="mt-3 mb-4">
									<label>
										{{ $t("CMS.homePage.titleLabel") }}
										<span class="text-danger">*</span>
										<span class="ml-2">
											<p
												v-if="danube_title"
												class="badge position-absolute"
												:class="{
													'badge-light': danube_title.length !== 30,
													'badge-danger': danube_title.length === 30,
												}"
											>
												{{ danube_title.length }} / 30
											</p>
										</span>
									</label>
									<b-form-group>
										<b-form-input
											v-model="danube_title"
											:placeholder="
												this.$i18n.t('CMS.homePage.titlePlaceholder')
											"
											:maxlength="30"
											:class="{ 'is-invalid': $v.danube_title.$error }"
										></b-form-input>
										<div v-if="$v.danube_title.$error" class="invalid-feedback">
											<span
												v-if="
													$v.danube_title.$error && !$v.danube_title.required
												"
												>{{ $t("packages.editPackage.titleRequiredMsg") }}</span
											>
										</div>
									</b-form-group>
								</div>
								<div class="mt-3 mb-4">
									<label>
										{{ $t("CMS.homePage.titleLabel") }}
										<span class="text-danger">*</span>
										<span class="ml-2">
											<p
												v-if="danube_description"
												class="badge position-absolute"
												:class="{
													'badge-light': danube_description.length !== 265,
													'badge-danger': danube_description.length === 265,
												}"
											>
												{{ danube_description.length }} / 265
											</p>
										</span>
									</label>
									<textarea
										v-model="danube_description"
										class="form-control"
										name="textarea"
										rows="3"
										:maxlength="265"
										:placeholder="
											this.$i18n.t('CMS.homePage.descriptionPlaceholder')
										"
										:class="{ 'is-invalid': $v.danube_description.$error }"
									></textarea>
									<div
										v-if="$v.danube_description.$error"
										class="invalid-feedback"
									>
										<span
											v-if="
												$v.danube_description.$error &&
													!$v.danube_description.required
											"
											>{{
												$t("packages.editPackage.descriptionRequiredMsg")
											}}</span
										>
									</div>
								</div>
								<div class="mt-3 mb-4">
									<label>
										Video-URL
										<span class="text-danger">*</span>
										<span class="ml-2"> </span>
									</label>
									<b-form-group>
										<b-form-input
											v-model="danube_videolink"
											:placeholder="
												this.$i18n.t('CMS.homePage.titlePlaceholder')
											"
											:class="{ 'is-invalid': $v.danube_videolink.$error }"
										></b-form-input>
										<div
											v-if="$v.danube_videolink.$error"
											class="invalid-feedback"
										>
											<span
												v-if="
													$v.danube_videolink.$error &&
														!$v.danube_videolink.required
												"
												>{{ $t("packages.editPackage.titleRequiredMsg") }}</span
											>
										</div>
									</b-form-group>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Image Slider Section -->
		<div class="row mt-4">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<div class="card-title">Slider Bilder</div>
						<div class="row mt-5 ml-5">
							<!-- Image 1 -->
							<div class="col-md-6 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="extraImagePreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageOne ? '' : 'none'}`
										"
									>
										<canvas
											id="extraImageCanvas"
											ref="extraImageCanvas"
											height="120"
											width="120"
										></canvas>
									</span>
									<span
										v-if="!this.croppedSliderImageOne"
										class=""
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="slider_galary[0]"
											class="rounded-0"
											alt
											height="200"
											width="200"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-6 mb-4">
								<div class="">
									<input
										id="extraImageInput"
										ref="extraImageInput"
										type="file"
										name="file"
										accept="image/*"
										@change="extraImageSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="extraImageInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
								<div class="row">
									<div class="col-md-8 mt-4 mb-4 ml-3">
										<label>
											URL
											<span class="text-danger">*</span>
										</label>
										<b-form-group>
											<b-form-input
												v-model="slider_URL[0]"
												:placeholder="
													this.$i18n.t('CMS.homePage.titlePlaceholder')
												"
											></b-form-input>
										</b-form-group>
									</div>
								</div>
							</div>

							<!-- Image 2 -->
							<div class="col-md-6 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="sliderImageTwoPreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageTwo ? '' : 'none'}`
										"
									>
										<canvas
											id="sliderImageTwoCanvas"
											ref="sliderImageTwoCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedSliderImageTwo"
										class=""
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="slider_galary[1]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-6 mb-4">
								<div class="">
									<input
										id="sliderImageTwoInput"
										ref="sliderImageTwoInput"
										type="file"
										name="file"
										accept="image/*"
										@change="sliderImageTwoSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="sliderImageTwoInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
								<div class="row">
									<div class="col-md-8 mt-4 mb-4 ml-3">
										<label>
											URL
											<span class="text-danger">*</span>
										</label>
										<b-form-group>
											<b-form-input
												v-model="slider_URL[1]"
												:placeholder="
													this.$i18n.t('CMS.homePage.titlePlaceholder')
												"
											></b-form-input>
										</b-form-group>
									</div>
								</div>
							</div>

							<!-- Image 3 -->
							<div class="col-md-6 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="sliderImageThreePreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageThree ? '' : 'none'}`
										"
									>
										<canvas
											id="sliderImageThreeCanvas"
											ref="sliderImageThreeCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedSliderImageThree"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="slider_galary[2]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-6 mb-4">
								<div class="">
									<input
										id="sliderImageThreeInput"
										ref="sliderImageThreeInput"
										type="file"
										name="file"
										accept="image/*"
										@change="sliderImageThreeSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="sliderImageThreeInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
								<div class="row">
									<div class="col-md-8 mt-4 mb-4 ml-3">
										<label>
											URL
											<span class="text-danger">*</span>
										</label>
										<b-form-group>
											<b-form-input
												v-model="slider_URL[2]"
												:placeholder="
													this.$i18n.t('CMS.homePage.titlePlaceholder')
												"
											></b-form-input>
										</b-form-group>
									</div>
								</div>
							</div>

							<!-- Image 4 -->
							<div class="col-md-6 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="sliderImageFourPreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageFour ? '' : 'none'}`
										"
									>
										<canvas
											id="sliderImageFourCanvas"
											ref="sliderImageFourCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedSliderImageFour"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="slider_galary[3]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-6 mb-4">
								<div class="">
									<input
										id="sliderImageFourInput"
										ref="sliderImageFourInput"
										type="file"
										name="file"
										accept="image/*"
										@change="sliderImageFourSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="sliderImageFourInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
								<div class="row">
									<div class="col-md-8 mt-4 mb-4 ml-3">
										<label>
											URL
											<span class="text-danger">*</span>
										</label>
										<b-form-group>
											<b-form-input
												v-model="slider_URL[3]"
												:placeholder="
													this.$i18n.t('CMS.homePage.titlePlaceholder')
												"
											></b-form-input>
										</b-form-group>
									</div>
								</div>
							</div>

							<!-- Image 5 -->
							<div class="col-md-6 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="sliderImageFivePreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageFive ? '' : 'none'}`
										"
									>
										<canvas
											id="sliderImageFiveCanvas"
											ref="sliderImageFiveCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedSliderImageFive"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="slider_galary[4]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-6 mb-4">
								<div class="">
									<input
										id="sliderImageFiveInput"
										ref="sliderImageFiveInput"
										type="file"
										name="file"
										accept="image/*"
										@change="sliderImageFiveSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="sliderImageFiveInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
								<div class="row">
									<div class="col-md-8 mt-4 mb-4 ml-3">
										<label>
											URL
											<span class="text-danger">*</span>
										</label>
										<b-form-group>
											<b-form-input
												v-model="slider_URL[4]"
												:placeholder="
													this.$i18n.t('CMS.homePage.titlePlaceholder')
												"
											></b-form-input>
										</b-form-group>
									</div>
								</div>
							</div>

							<!-- Image 6 -->
							<div class="col-md-6 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="sliderImageSixPreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageSix ? '' : 'none'}`
										"
									>
										<canvas
											id="sliderImageSixCanvas"
											ref="sliderImageSixCanvas"
											height="120"
											width="120"
										></canvas>
									</span>
									<span
										v-if="!this.croppedSliderImageSix"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="slider_galary[5]"
											class="rounded-0"
											alt
											height="200"
											width="200"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-6 mb-4">
								<div class="">
									<input
										id="sliderImageSixInput"
										ref="sliderImageSixInput"
										type="file"
										name="file"
										accept="image/*"
										@change="sliderImageSixSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="sliderImageSixInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
								<div class="row">
									<div class="col-md-8 mt-4 mb-4 ml-3">
										<label>
											URL
											<span class="text-danger">*</span>
										</label>
										<b-form-group>
											<b-form-input
												v-model="slider_URL[5]"
												:placeholder="
													this.$i18n.t('CMS.homePage.titlePlaceholder')
												"
											></b-form-input>
										</b-form-group>
									</div>
								</div>
							</div>

							<!-- Image 7 -->
							<div class="col-md-6 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="sliderImageSevenPreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageSeven ? '' : 'none'}`
										"
									>
										<canvas
											id="sliderImageSevenCanvas"
											ref="sliderImageSevenCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedSliderImageSeven"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="slider_galary[6]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-6 mb-4">
								<div class="">
									<input
										id="sliderImageSevenInput"
										ref="sliderImageSevenInput"
										type="file"
										name="file"
										accept="image/*"
										@change="sliderImageSevenSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="sliderImageSevenInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
								<div class="row">
									<div class="col-md-8 mt-4 mb-4 ml-3">
										<label>
											URL
											<span class="text-danger">*</span>
										</label>
										<b-form-group>
											<b-form-input
												v-model="slider_URL[6]"
												:placeholder="
													this.$i18n.t('CMS.homePage.titlePlaceholder')
												"
											></b-form-input>
										</b-form-group>
									</div>
								</div>
							</div>

							<!-- Image 8 -->
							<div class="col-md-6 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="sliderImageEightPreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageEight ? '' : 'none'}`
										"
									>
										<canvas
											id="sliderImageEightCanvas"
											ref="sliderImageEightCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedSliderImageEight"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="slider_galary[7]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-6 mb-4">
								<div class="">
									<input
										id="sliderImageEightInput"
										ref="sliderImageEightInput"
										type="file"
										name="file"
										accept="image/*"
										@change="sliderImageEightSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="sliderImageEightInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
								<div class="row">
									<div class="col-md-8 mt-4 mb-4 ml-3">
										<label>
											URL
											<span class="text-danger">*</span>
										</label>
										<b-form-group>
											<b-form-input
												v-model="slider_URL[7]"
												:placeholder="
													this.$i18n.t('CMS.homePage.titlePlaceholder')
												"
											></b-form-input>
										</b-form-group>
									</div>
								</div>
							</div>

							<!-- Image 9 -->
							<div class="col-md-6 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="sliderImageNinePreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageEight ? '' : 'none'}`
										"
									>
										<canvas
											id="sliderImageNineCanvas"
											ref="sliderImageNineCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedSliderImageNine"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="slider_galary[8]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-6 mb-4">
								<div class="">
									<input
										id="sliderImageNineInput"
										ref="sliderImageNineInput"
										type="file"
										name="file"
										accept="image/*"
										@change="sliderImageNineSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="sliderImageNineInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
								<div class="row">
									<div class="col-md-8 mt-4 mb-4 ml-3">
										<label>
											URL
											<span class="text-danger">*</span>
										</label>
										<b-form-group>
											<b-form-input
												v-model="slider_URL[8]"
												:placeholder="
													this.$i18n.t('CMS.homePage.titlePlaceholder')
												"
											></b-form-input>
										</b-form-group>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-3">
			<b-button
				variant="success"
				@click="clickSaveButton()"
				:disabled="editHomepageProcessing"
			>
				<i class="bx bxs-save mr-1"></i>
				{{ $t("general.buttons.save") }}</b-button
			>
		</div>

		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showSliderImageOneCropModel === true"
			:visible="showSliderImageOneCropModel"
			@close="showSliderImageOneCropModel = false"
			:imageFile="sliderImageOneFileToCrop"
			@apply="setCroppedImageToPreview"
		/>
		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showSliderImageTwoCropModel === true"
			:visible="showSliderImageTwoCropModel"
			@close="showSliderImageTwoCropModel = false"
			:imageFile="sliderImageTwoFileToCrop"
			@apply="setCroppedSliderImageTwoToPreview"
		/>
		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showSliderImageThreeCropModel === true"
			:visible="showSliderImageThreeCropModel"
			@close="showSliderImageThreeCropModel = false"
			:imageFile="sliderImageThreeFileToCrop"
			@apply="setCroppedSliderImageThreeToPreview"
		/>

		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showSliderImageFourCropModel === true"
			:visible="showSliderImageFourCropModel"
			@close="showSliderImageFourCropModel = false"
			:imageFile="sliderImageFourFileToCrop"
			@apply="setCroppedSliderImageFourToPreview"
		/>
		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showSliderImageFiveCropModel === true"
			:visible="showSliderImageFiveCropModel"
			@close="showSliderImageFiveCropModel = false"
			:imageFile="sliderImageFiveFileToCrop"
			@apply="setCroppedSliderImageFiveToPreview"
		/>

		<!-- Image Cropper Model 6 -->
		<image-cropper-model
			v-if="this.showSliderImageSixCropModel === true"
			:visible="showSliderImageSixCropModel"
			@close="showSliderImageSixCropModel = false"
			:imageFile="sliderImageSixFileToCrop"
			@apply="setCroppedSliderImageSixToPreview"
		/>

		<!-- Image Cropper Model 7 -->
		<image-cropper-model
			v-if="this.showSliderImageSevenCropModel === true"
			:visible="showSliderImageSevenCropModel"
			@close="showSliderImageSevenCropModel = false"
			:imageFile="sliderImageSevenFileToCrop"
			@apply="setCroppedSliderImageSevenToPreview"
		/>

		<!-- Image Cropper Model 8 -->
		<image-cropper-model
			v-if="this.showSliderImageEightCropModel === true"
			:visible="showSliderImageEightCropModel"
			@close="showSliderImageEightCropModel = false"
			:imageFile="sliderImageEightFileToCrop"
			@apply="setCroppedSliderImageEightToPreview"
		/>

		<!-- Image Cropper Model 9 -->
		<image-cropper-model
			v-if="this.showSliderImageNineCropModel === true"
			:visible="showSliderImageNineCropModel"
			@close="showSliderImageNineCropModel = false"
			:imageFile="sliderImageNineFileToCrop"
			@apply="setCroppedSliderImageNineToPreview"
		/>
	</Layout>
</template>

<style scoped>
.text-limted-one-lines {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1; /* number of lines to show */
	-webkit-box-orient: vertical;
}
.text-limted-two-lines {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2; /* number of lines to show */
	-webkit-box-orient: vertical;
}

.extra-image-preview-after-crop {
	/* display: flex;
  justify-content: center;
  align-items: center; */
	background-color: none;
	width: 200px;
	height: 200px;
	padding: 0;
	margin: 0;
}
</style>
